

































































































































/* Created- 22 - Mar - 2019 */

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ArticleModel, CurationInfoDTO } from "../../../Generated/ParticaAPI";
import ArticleTitle from "@/Ui-Components/Article/Common/ArticleTitle.vue";
import ArticleAbstract from "@/Ui-Components/Article/Common/ArticleAbstract.vue";
import ArticleBody from "@/Ui-Components/Article/Common/ArticleBodyV4.vue";
import ArticleSubheading from "@/Ui-Components/Article/Common/ArticleSubheading.vue";
import ArticleImages from "@/Ui-Components/Article/Common/ArticleImages.vue";
import ArticleContributors from "@/Ui-Components/Article/Common/ArticleContributors.vue";

import ArticleFacebook from "@/Ui-Components/Article/Curate/ArticleFacebook.vue";
import ArticleLinkedin from "@/Ui-Components/Article/Curate/ArticleLinkedin.vue";
import ArticleInstagram from "@/Ui-Components/Article/Curate/ArticleInstagram.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { ICuratedArticle } from "../../../Models/ArticleModels/article";
import { ParticaEvent, eParticaAction } from "../../../Models/ParticaEvent";
import { ButtonConfig } from "../../../Models/Buttons";



@Component(
	{
		name: "ParticaArticleCurate",
		components: {
			ArticleTitle,
			ArticleBody,
			ArticleImages,
			ParticaRowContainer,
			ArticleAbstract,
			ArticleSubheading,
			ButtonList,
			ParticaColumnContainer,
			ArticleFacebook,
			ArticleLinkedin,
			ArticleInstagram,
			ParticaCard,
			ArticleContributors
		}
	})
export default class ParticaArticleCurate extends Vue {
	@Prop() private article: ICuratedArticle; // your data
	@Prop() private curationInfo: CurationInfoDTO;
	@Prop() private show: boolean;
	@Prop() private buttons: ButtonConfig[];
	@Prop() private title: string;
	private active: number = 0;

	@Watch("show")
	private closed() {
		if (this.show === false) {
			// reset active tab to 'properties'
			this.active = 0;
		}
	}
	private buttonClicked(clicked: ParticaEvent) {
		this.$emit("partica-event", clicked);
	}

	private eventHandler(event: ParticaEvent) {
		this.$emit("partica-event", event);
	}

	private deleteArticle() {
		const deleteEvent: ParticaEvent = { item: this.article, action: eParticaAction.ARTICLE_DELETE } as ParticaEvent;
		this.$emit("partica-event", deleteEvent);
	}

	private keyboard(val: string, event: any) {
		switch (val) {
			case "SAVE": {
				this.$emit("partica-event", { action: eParticaAction.ARTICLE_SAVE } as ParticaEvent);
				this.$nextTick(() => {
					event.srcElement.focus(); // keep focus in the input that generated the event
				});
				break;
			}
			case "CLOSE": {
				this.$emit("close", {} as ParticaEvent);
				break;
			}
		}
	}


}
